/* eslint-disable max-len */
import React,{useState, useEffect, useContext} from 'react'
import { motion } from 'framer-motion'
import CustomToast from '../../Components/AlertPopup';
import { distributorService } from '../../service/distributor.service';
import Banner from './Components/Banner';
import CreditStatus from './Components/CreditStatus';
import Footer from './Components/Footer';
import RecentInvoices from './Components/RecentInvoices';
import RecentlyOrderedProducts from './Components/RecentlyOrderedProducts';
import RecentOrders from './Components/RecentOrders';
import RecentResources from './Components/RecentResources';
import StatisticsAndMIS from './Components/statisticsAndMIS';
import Value from './Components/Value';
import VideoPlayerModal from './Components/VideoPlayerModal';
import ViewInvoice from '../ListOfInvoices/ViewInvoice';
import VirtualPaymentModal from '../ListOfInvoices/Modals/VirtualPaymentModal';
import RequestToReturnModal from '../ListOfInvoices/Modals/RequestToReturnModal';
import HeaderContext from '../../Components/Context/HeaderContext';


function HomePage() {
    const {
        SetSuccessMessage,
        setcolorValue,
        SetErrorMessage,
        setisPopup
    } = useContext(HeaderContext);
    const [title, settitle] = useState(' Otp Verification Successful!');
    const [showPopup, setshowPopup] = useState(false);
    const [color, setcolor] = useState('');
    const [recentOrders, setRecentOrders] = useState([]);
    const [recentInvoices, setRecentInvoices] = useState([]);
    const [dashboardData, setDashboardData] = useState([]);
    const [recentResource, setRecentResource] = useState([]);
    const [videoPlayerPopup, setVideoplayerPopup] = useState(false);
    const [selectedResource, setSelectedResource] = useState({});
    const [DISTRIBUTOR, setDISTRIBUTOR] = useState([])
    const [orderProducts, setOrderProducts] = useState([])
    const [currentYear, setCurrentYear] = useState({})
    const [orderData, setOrderData] = useState([])
    const [viewModalPopup, setViewModalPopup] = useState(false)
    const [viewInvoiceDetails, setViewInvoiceDetails] = useState(null)
    const [virtualPaymentModal, setVirtualPaymentModal] = useState(false)
    const [returnRequestModal, setReturnRequestModal] = useState(false)
    const [selectedInvoiceNumber, setSelectedInvoiceNumber] = useState([])
    const [bannerList, setBannerList] = useState([])
    const [requestData, setRequestData] = useState({
        reason:'',
        attached_file:[],
    })


    const animations = {
        initial: { opacity: 0.5, x: -10 },
        animate: { opacity: 1, x: 0 },
        exit: { opacity: 0, x: 0 }
    }

    const handleFetchDashboardData = async () => {
        const {distributor} = JSON.parse(localStorage.getItem('user')).profile
        const responseData = await distributorService.DashboardData(distributor.ACCOUNT_NUMBER)
        setDashboardData(responseData.data)
    }
        
    const handleDistributor = async () => {
        const res = await distributorService.Getprofile()
        if(res.data.success_status === true){
            setDISTRIBUTOR(res.data.data)
        }
    }

    const handleOrderProducts = async () => {
        const res = await distributorService.RecentOrderProducts()
        if(res.data.success_status === true){
            setOrderProducts(res.data.data)
        }
    }

    const handleRecentOrders = async () => {
        const res = await distributorService.RecentOrderList()
        if(res.data.data.success_status === true){
            if(res.data.data.Items.length > 0){
                setRecentOrders(res.data.data.Items)
            }
        }
    }

    const handleOrderData = async (year,date_range) => {
        const res = await distributorService.OrderData(year,date_range)
        if(res.data.success_status === true){
            setOrderData(res.data.data)
        }
    }

    const handleRecentInvoices = async () => {
        const res = await distributorService.RecentInvoiceList()
        if(res.data.data.success_status === true){
            if(res.data.data.Items.length > 0){
                setRecentInvoices(res.data.data.Items)
            }
        }
    }

    const  handleViewInvoiceDetails = async (invoiceNumber) => {
        setViewModalPopup(true)
        const res = await distributorService.ViewInvoicesDetails(invoiceNumber);
        setViewInvoiceDetails(res.data.data)
    }

    const handleReturnToRequest = async (item) => {
        setReturnRequestModal(true)
        setSelectedInvoiceNumber(item)
        // const payload = {
        //     reason:requestData.reason,
        //     attached_file:requestData.attached_file,
        // }
        // const returnResponse = await distributorService.UpdateInvoiceList(item?.INDENT_NUMBER, payload)
    }

    const ProceedreturnRequest = async () => {
        const payload = {
            reason:requestData.reason,
            attached_file:requestData.attached_file,
        }
        const returnResponse = await distributorService.UpdateInvoiceList(DISTRIBUTOR.ACCOUNT_NUMBER,selectedInvoiceNumber?.INDENT_NUMBER, payload)
        if(returnResponse.error === true){
            setReturnRequestModal(false)
            SetErrorMessage(returnResponse.message.message)
            setcolorValue('red')
            setTimeout(() => {
                SetErrorMessage('') 
                setcolorValue('')              
            }, 1000);
        } else {
            setReturnRequestModal(false)
            SetSuccessMessage(returnResponse.message.message)
            setTimeout(() => {
                SetSuccessMessage('') 
                setcolorValue('')              
            }, 1000);
        }
    }
  
    const handleFetchRecentResources = async () => {
        const response = await distributorService.ResourceList('1', '', 'published_date+desc' ,'')
        if(response.data.success_status === true){
            setRecentResource(response.data.data.Items)
        }
    }

    const handleFetchBanners = async () => {
        const response = await distributorService.BannerList()
        if(response.error === false) {
            setBannerList(response.data.data.Items)
        }
    }

    useEffect(() => {
        handleRecentOrders()
        handleRecentInvoices()
        handleFetchDashboardData()
        handleFetchRecentResources()
        const successStatus = localStorage.getItem('success-popup');
        handleDistributor()
        handleOrderProducts()
        handleOrderData('','')
        handleFetchBanners()
        document.body.style.overflow = 'unset';

        if (successStatus == 1) {
            setshowPopup(true);
            setTimeout(() => {
                setshowPopup(false);
            }, 2000);
            localStorage.setItem('success-popup', Number(successStatus + 1));
        }
    }, []);
    function OtpSuccessMeessage() {
        return (
            <p className=" text-[#090406] font-medium pl-[54px] py-3" style={{ fontSize: '15px', color: '#808285' }}>
                {title}
            </p>
        );
    }
    return (
        <div className="lg:px-[54px] md:px-[46px] px-4 mb-10">
            {
                showPopup && (
                    <CustomToast
                        open
                        color={color ? '#ED1C24' : undefined}
                        message={<OtpSuccessMeessage />}
                    />
                )
            }
            <div className="flex sm:flex-row flex-col justify-between sm:items-center items-start sm:mt-[30px] mt-3.5">
                <p className="sm:text-xs10 text-lg font-semibold text-[#090406]"> <span className="text-[#808285]">Welcome</span>{' '}{DISTRIBUTOR.PARTY_NAME}</p>
            </div>
            <motion.div
                variants={animations}
                initial="initial"
                animate="animate"
                exit="exit"
                transition={{ duration: 2 }}>
                <div className="mt-[30px] flex flex-wrap lg:flex-nowrap  w-full">
                    <StatisticsAndMIS 
                        DISTRIBUTOR={DISTRIBUTOR} 
                        currentYear={currentYear} 
                        setCurrentYear={setCurrentYear}  
                        handleOrderData= {handleOrderData} 
                        orderData={orderData}
                    />
                    <Value 
                        handleOrderData= {handleOrderData} 
                        orderData={orderData}
                    />
                    <CreditStatus 
                        DISTRIBUTOR={DISTRIBUTOR}
                        orderData={orderData}
                    />
                </div>                    
                {orderProducts.length > 0 && (
                    <RecentlyOrderedProducts 
                        orderProducts={orderProducts} 
                    />)}                
            </motion.div>
            {recentOrders.length > 0 && (
                <RecentOrders 
                    setRecentOrders={setRecentOrders}
                    recentOrders={recentOrders}
                />
            )}         
            {recentInvoices.length > 0 && (
                <RecentInvoices 
                    recentInvoices={recentInvoices}
                    setRecentInvoices={setRecentInvoices}
                    handleViewInvoiceDetails={handleViewInvoiceDetails}
                    viewInvoiceDetails={viewInvoiceDetails}
                    virtualPaymentModal={virtualPaymentModal}
                    setVirtualPaymentModal={setVirtualPaymentModal}  
                    handleReturnToRequest={handleReturnToRequest}                 
                />
            )}          
            {recentResource.length > 0 && (
                <RecentResources
                    recentResource={recentResource}
                    setRecentResource={setRecentResource}
                    selectedResource={selectedResource}
                    setSelectedResource={setSelectedResource}
                    videoPlayerPopup={videoPlayerPopup} 
                    setVideoplayerPopup={setVideoplayerPopup} 
                />
            )}     
            {videoPlayerPopup && 
                <VideoPlayerModal 
                    videoPlayerPopup={videoPlayerPopup} 
                    setVideoplayerPopup={setVideoplayerPopup} 
                    selectedResource={selectedResource}
                    setSelectedResource={setSelectedResource}                
                />
            }     
            <Banner
                bannerList={bannerList}
                setBannerList={setBannerList} 
            />
            <Footer />
            {viewModalPopup && viewInvoiceDetails !== null && <ViewInvoice 
                viewModalPopup={viewModalPopup} 
                setViewModalPopup={setViewModalPopup}  
                viewInvoiceDetails={viewInvoiceDetails} 
                setViewInvoiceDetails={setViewInvoiceDetails}
            />}
            {virtualPaymentModal && <VirtualPaymentModal 
                virtualPaymentModal={virtualPaymentModal} 
                setVirtualPaymentModal={setVirtualPaymentModal}
            />}
            {returnRequestModal && <RequestToReturnModal 
                returnRequestModal={returnRequestModal} 
                setReturnRequestModal={setReturnRequestModal} 
                viewInvoiceDetails={viewInvoiceDetails} 
                selectedInvoiceNumber={selectedInvoiceNumber}
                requestData={requestData}
                setRequestData={setRequestData}
                handleReturnToRequest={handleReturnToRequest}
                ProceedreturnRequest={ProceedreturnRequest}
            />}
        </div>
        
    )
    
}

export default HomePage